"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'Tag',
    props: {
        tag: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            required: true,
        },
        type: {
            type: String,
        },
    },
    methods: {
        getClasses() {
            const classes = ['tag-count', 'tooltip', 'tooltip-bottom'];
            classes.push(`tag-${this.tag}`);
            if (this.size !== undefined) {
                classes.push(`tag-size-${this.size}`);
            }
            if (this.type !== undefined) {
                classes.push(`tag-type-${this.type}`);
            }
            return classes.join(' ');
        },
    },
});
